import { render, staticRenderFns } from "./VideoRecord.vue?vue&type=template&id=312a918f&"
import script from "./VideoRecord.vue?vue&type=script&lang=js&"
export * from "./VideoRecord.vue?vue&type=script&lang=js&"
import style0 from "./VideoRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports